import script from "./hotelList.vue?vue&type=script&setup=true&lang=js"
export * from "./hotelList.vue?vue&type=script&setup=true&lang=js"

import "./hotelList.vue?vue&type=style&index=0&id=755cd06a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-755cd06a"]])

export default __exports__